<template lang="pug">
AppSidebar(
  :visible="visible"
  @close="onClose"
)
  AppTabs(compact)
    AppTab(label="Filters")
      ActivitiesLazyMembersSelect.basic-filters(with-label)
      ActivitiesProjectFilter
      .row
        .col-sm-12.basic-filters
          label Time type
          ActivitiesTimeTypeFilter(v-model="timeType")
      .row
        .col-sm-12.basic-filters
          label Source
          ActivitiesClientTypeFilter(
            v-model="clientType"
            :options="clientTypeFilters"
          )
      .row
        .col-sm-12.basic-filters
          label Activity Level
          ActivitiesActivityLevelFilter(v-model="activityLevel")
      .mt-40
        AppButton.clear-filters(
          block
          @click="clearFilters"
        )
          | Clear filters
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import ActivitiesActivityLevelFilter from './ActivitiesActivityLevelFilter.vue';
import ActivitiesLazyMembersSelect from './ActivitiesLazyMembersSelect.vue';
import ActivitiesProjectFilter from './ActivitiesProjectFilter.vue';
import ActivitiesTimeTypeFilter from './ActivitiesTimeTypeFilter.vue';
import ActivitiesClientTypeFilter from './ActivitiesClientTypeFilter.vue';
import select2DropdownParentMixin from '~/mixins/Select2DropdownParent';

export default {
  name: 'ActivitiesFilterSidebar',
  components: {
    ActivitiesActivityLevelFilter,
    ActivitiesClientTypeFilter,
    ActivitiesLazyMembersSelect,
    ActivitiesProjectFilter,
    ActivitiesTimeTypeFilter,
  },
  mixins: [select2DropdownParentMixin],
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['queryFilters', 'clientTypeFilters']),
    activityLevel: {
      get() {
        return this.queryFilters.activity_level;
      },
      set(activityLevel) {
        this.setFilter({ activity_level: activityLevel });
      },
    },
    timeType: {
      get() {
        let timeTypes = this.queryFilters.time_types;

        if (timeTypes) {
          timeTypes = timeTypes[0];
        }

        return timeTypes;
      },
      set(timeType) {
        this.setFilter({ time_types: timeType ? [timeType] : [] });
      },
    },
    clientType: {
      get() {
        let clientType = this.queryFilters.client_types;

        if (clientType) {
          clientType = clientType[0];
        }

        return clientType;
      },
      set(clientType) {
        this.setFilter({ client_types: clientType ? [clientType] : [] });
      },
    },
  },
  methods: {
    ...mapActions(['setFilter', 'clearFilters']),
    onClose() {
      this.$emit('close');
    },
  },
};
</script>
